module.exports = __webpack_public_path__ + "img/corner_video_camera.d34d56c0.svg";